// The dashboard's layout, the same on every device (the owner, 29.09.2026): the household carries
// it (`dashboardBoard`, `dashboardList`), each device keeps a copy for a quick start.

type LayoutSource = {
  /** What this device shows: the stored JSON, null for the default of its kind of screen. */
  readonly show: string | null;
  /** Whether this device sends its own layout to the household (once, the first to share). */
  readonly send: boolean;
  /** Whether the household's layout is this device's from now on. */
  readonly adopted: boolean;
};

/**
 * Which layout a device shows. `remote` is the household's field: undefined while the server does
 * not know it yet (an older backend: the device keeps its layout to itself), null for the default.
 * A device that has never taken the household's layout sends its own when the household has none,
 * so the layout set before sharing is not lost; after that the household's is the layout, the
 * default included - a reset on one device is a reset everywhere.
 */
export function layoutSource(input: { local: string | null; remote: string | null | undefined; adopted: boolean }): LayoutSource {
  if (input.remote === undefined) return { show: input.local, send: false, adopted: input.adopted };
  if (!input.adopted && input.remote === null && input.local !== null) return { show: input.local, send: true, adopted: true };
  return { show: input.remote, send: false, adopted: true };
}
